
// Google Reviews data for testimonials
export const googleReviews = [
  {
    quote: "Great unique experience! I am a cat loving local and did a tour to celebrate my birthday. The tour provides a history of certain areas and buildings in NYC highlighting the cats that made the neighborhood what it is today.",
    author: "Tracy H.",
    role: "Local cat lover",
    source: "Google Review"
  },
  {
    quote: "I loved this tour so much! Peggy is wonderful, and so many of the stops along the tour highlight the history of New York, Brooklyn, and Brooklyn Heights alongside the great feline tales. It was a joy to spend the afternoon on this lovely tour.",
    author: "Kate K.",
    role: "Brooklyn Heights visitor",
    source: "Google Review"
  },
  {
    quote: "Really enjoyed my walking tour! Took the FiDi route and learned so much about the history of NYC and the felines who helped it become what it is today! Especially appreciated the happier stories.",
    author: "A.B.",
    role: "Financial District tour guest",
    source: "Google Review"
  },
  {
    quote: "What a purrfect experience! Peggy led us around the beautiful, historic streets of Brooklyn Heights, telling us fascinating, mind-blowing, and adorable tales of cat's past, as well as their relationships with the New Yorkers of yesteryear.",
    author: "Marie C.",
    role: "History enthusiast",
    source: "Google Review"
  },
  {
    quote: "Wonderful tour not only regarding cats but about Brooklyn. Super fun and educated tour leader and the tour group was small so there was much opportunity to ask questions. Tour was also extremely well paced. Highly recommend!",
    author: "Rachel",
    role: "Walking tour enthusiast",
    source: "Google Review"
  },
  {
    quote: "What a purrfect and captivating way to experience cats of New York! Jenny was so lovely and engaging on our tour and I learned so much, not only about cats, but about the history of New York and how they both intertwine.",
    author: "Melissa P.",
    role: "NYC explorer",
    source: "Google Review"
  },
  {
    quote: "You don't have to be a crazy cat person to enjoy this walking tour! Some places I had never visited before; some I knew of, but not the feline history behind. Unique stories amongst the beautiful Brooklyn Heights backdrop.",
    author: "DeeAnne G.",
    role: "Brooklyn explorer",
    source: "Google Review"
  },
  {
    quote: "I had an amazing time on the Cats About Town Walking Tour in Brooklyn Heights! Peggy shared such cool stories about NYC's famous cats and their history. If you love cats and want to see New York in a totally unique way, this tour is a must.",
    author: "Mauricio M.",
    role: "Cat lover",
    source: "Google Review"
  },
  {
    quote: "If you want a unique NYC experience, this is it! This is not a general history tour, but instead a way to better get to know different neighborhoods in NYC through the lens of precious true cat stories.",
    author: "Marina N.",
    role: "Unique experience seeker",
    source: "Google Review"
  },
  {
    quote: "So glad I booked this! Such a cool unique thing to do in BK, me and my friends had a great time. Our guide, Peggy, was entertaining and informative. 10/10, highly recommend.",
    author: "Raquel S.",
    role: "Friend group visitor",
    source: "Google Review"
  }
];
